import { type HTMLAttributes, type ReactNode } from 'react';
import { cn } from './cn';

export interface StickyFooterProps extends HTMLAttributes<HTMLDivElement> {
  /** 좌측 메타 정보 — 마지막 저장 시각 등 */
  meta?: ReactNode;
  children: ReactNode;
}

/**
 * Form 페이지 sticky 액션 바.
 * 페이지 콘텐츠 컨테이너 내부에서 negative margin 으로 좌우 padding 흡수하여
 * 컨텐츠 영역 끝까지 가로 확장. RootLayout main 의 viewport scroll 에 sticky.
 */
export const StickyFooter = ({
  meta,
  children,
  className,
  ...props
}: StickyFooterProps) => (
  <div
    className={cn(
      'sticky bottom-0 z-10 -mx-6 mt-4 flex items-center gap-3 px-6 py-3 lg:-mx-8 lg:px-8',
      className,
    )}
    style={{
      background: 'color-mix(in srgb, var(--surface-0) 92%, transparent)',
      backdropFilter: 'blur(8px)',
      borderTop: '1px solid var(--divider-strong)',
    }}
    {...props}
  >
    {meta ? (
      <div className="mr-auto text-[12px]" style={{ color: 'var(--content-muted)' }}>
        {meta}
      </div>
    ) : null}
    <div className="ml-auto flex items-center gap-2">{children}</div>
  </div>
);
